export const transactionDefaultValues = {
  cost_date: null,
  vendor_name: "",
  transaction_date: "",
  total_amount: "",
  comment: "",
  attachments: [],
};
